/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.6",
    versionName: "0.2.0-nightly.2025.8.6",
    versionChannel: "nightly",
    buildDate: "2025-08-06T00:09:29.072Z",
    commitHash: "4c8c4f5a8dbd7305a239d85a4162e0c3c2133fa3",
};
